import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "compute-balance" }
const _hoisted_2 = { class: "compute-balance-body" }
const _hoisted_3 = { class: "sticky" }
const _hoisted_4 = { class: "picker" }
const _hoisted_5 = { class: "balance-kpis" }
const _hoisted_6 = { class: "balance-kpi__label" }
const _hoisted_7 = { class: "balance-kpi__value" }
const _hoisted_8 = { class: "header" }
const _hoisted_9 = { class: "compute-balance-header projectName" }
const _hoisted_10 = { class: "compute-balance-header ordersTotal" }
const _hoisted_11 = { class: "compute-balance-header performedTimesheetsTotal" }
const _hoisted_12 = { class: "compute-balance-header totalExpensesNet" }
const _hoisted_13 = { class: "compute-balance-header totalUninvoicedOfferedNet" }
const _hoisted_14 = { class: "compute-balance-header invoicedTotal" }
const _hoisted_15 = { class: "compute-balance-header toInvoice" }
const _hoisted_16 = { class: "compute-balance-header toInvoiceGross" }
const _hoisted_17 = { class: "compute-balance-header reportStatus" }
const _hoisted_18 = { class: "compute-balance-body" }
const _hoisted_19 = { class: "sticky" }
const _hoisted_20 = { class: "header" }
const _hoisted_21 = { class: "compute-balance-header projectName" }
const _hoisted_22 = { class: "compute-balance-header ordersTotal" }
const _hoisted_23 = { class: "compute-balance-header performedTimesheetsTotal" }
const _hoisted_24 = { class: "compute-balance-header totalExpensesNet" }
const _hoisted_25 = { class: "compute-balance-header totalUninvoicedOfferedNet" }
const _hoisted_26 = { class: "compute-balance-header invoicedTotal" }
const _hoisted_27 = { class: "compute-balance-header toInvoice" }
const _hoisted_28 = { class: "compute-balance-header toInvoiceGross" }
const _hoisted_29 = { class: "compute-balance-header reportStatus" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormItem = _resolveComponent("FormItem")!
  const _component_ClientInvoiceList = _resolveComponent("ClientInvoiceList")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_BaseSheet = _resolveComponent("BaseSheet")!
  const _component_MainContentBase = _resolveComponent("MainContentBase")!
  const _component_AddInvoice = _resolveComponent("AddInvoice")!
  const _component_EntityComments = _resolveComponent("EntityComments")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_FormItem, {
              input: _ctx.upUntil,
              "onUpdate:input": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.upUntil) = $event)),
              inputType: 'date',
              label: 'Up until',
              name: 'upUntil'
            }, null, 8, ["input"]),
            _createElementVNode("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpis, (kpi, key) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "balance-kpi",
                  key: key
                }, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(kpi.label), 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(kpi.value), 1)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.t("labels.clientName")), 1),
            _createElementVNode("li", _hoisted_10, _toDisplayString(_ctx.t("labels.ordersTotal")), 1),
            _createElementVNode("li", _hoisted_11, _toDisplayString(_ctx.t("labels.performedTimesheetsTotal")), 1),
            _createElementVNode("li", _hoisted_12, _toDisplayString(_ctx.t("labels.totalExpensesNet")), 1),
            _createElementVNode("li", _hoisted_13, _toDisplayString(_ctx.t("labels.totalUninvoicedOfferedNet")), 1),
            _createElementVNode("li", _hoisted_14, _toDisplayString(_ctx.t("labels.invoicedTotal")), 1),
            _createElementVNode("li", _hoisted_15, _toDisplayString(_ctx.t("labels.toInvoice")), 1),
            _createElementVNode("li", _hoisted_16, _toDisplayString(_ctx.t("labels.toInvoiceGross")), 1),
            _createElementVNode("li", _hoisted_17, _toDisplayString(_ctx.t("labels.status")), 1),
            _cache[11] || (_cache[11] = _createElementVNode("li", { class: "option-icon" }, null, -1))
          ])
        ]),
        _createVNode(_component_ClientInvoiceList, {
          ref: "positiveInvoiceList",
          query: _ctx.GET_CLIENTS_TO_INVOICE,
          "query-params": { upUntil: _ctx.upUntil, filterBalance: 'positive' },
          items: _ctx.toInvoice,
          "onUpdate:items": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toInvoice) = $event)),
          onActionOnClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showItemToInvoiceModal($event))),
          onShowComments: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showCommentsModal($event)))
        }, null, 8, ["query", "query-params", "items"])
      ]),
      _createVNode(_component_MainContentBase, null, {
        default: _withCtx(() => [
          _createVNode(_component_BaseSheet, {
            class: "sheet",
            "tag-name": "section"
          }, {
            header: _withCtx(() => [
              _createElementVNode("h3", {
                class: "sheet__title",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.switchAreNegativeVisible && _ctx.switchAreNegativeVisible(...args)))
              }, [
                _createVNode(_component_Icon, {
                  icon: "entypo:triangle-right",
                  rotate: _ctx.areNegativeVisible ? 1 : 0,
                  class: "icon-invoices-menu"
                }, null, 8, ["rotate"]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("titles.negativeBalance")), 1)
              ])
            ]),
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("ul", _hoisted_20, [
                      _createElementVNode("li", _hoisted_21, _toDisplayString(_ctx.t("labels.clientName")), 1),
                      _createElementVNode("li", _hoisted_22, _toDisplayString(_ctx.t("labels.ordersTotal")), 1),
                      _createElementVNode("li", _hoisted_23, _toDisplayString(_ctx.t("labels.performedTimesheetsTotal")), 1),
                      _createElementVNode("li", _hoisted_24, _toDisplayString(_ctx.t("labels.totalExpensesNet")), 1),
                      _createElementVNode("li", _hoisted_25, _toDisplayString(_ctx.t("labels.totalUninvoicedOfferedNet")), 1),
                      _createElementVNode("li", _hoisted_26, _toDisplayString(_ctx.t("labels.invoicedTotal")), 1),
                      _createElementVNode("li", _hoisted_27, _toDisplayString(_ctx.t("labels.toInvoice")), 1),
                      _createElementVNode("li", _hoisted_28, _toDisplayString(_ctx.t("labels.toInvoiceGross")), 1),
                      _createElementVNode("li", _hoisted_29, _toDisplayString(_ctx.t("labels.status")), 1),
                      _cache[12] || (_cache[12] = _createElementVNode("li", { class: "option-icon" }, null, -1))
                    ])
                  ]),
                  _createVNode(_component_ClientInvoiceList, {
                    ref: "negativeInvoiceList",
                    query: _ctx.GET_CLIENTS_TO_INVOICE,
                    "query-params": {
                upUntil: _ctx.upUntil,
                filterBalance: 'negative',
              },
                    items: _ctx.toPerform,
                    "onUpdate:items": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.toPerform) = $event)),
                    onActionOnClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showItemToInvoiceModal($event))),
                    onShowComments: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showCommentsModal($event)))
                  }, null, 8, ["query", "query-params", "items"])
                ])
              ], 512), [
                [_vShow, _ctx.areNegativeVisible]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.isItemToInvoiceModalVisible)
      ? (_openBlock(), _createBlock(_component_AddInvoice, {
          key: 0,
          onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.closeItemToInvoiceModal())),
          itemToInvoice: _ctx.clickedItemToInvoice,
          upUntil: _ctx.upUntil
        }, null, 8, ["itemToInvoice", "upUntil"]))
      : _createCommentVNode("", true),
    (_ctx.isCommentsModalVisible)
      ? (_openBlock(), _createBlock(_component_EntityComments, {
          key: 1,
          "entity-type": "CLIENT",
          "entity-id": _ctx.commentsEntityId,
          title: _ctx.commentsEntityTitle,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closeCommentsModal())),
          onChanged: _cache[10] || (_cache[10] = ($event: any) => (_ctx.refreshClientsToInvoice()))
        }, null, 8, ["entity-id", "title"]))
      : _createCommentVNode("", true)
  ], 64))
}